import { render, staticRenderFns } from "./MessageBoardComment.vue?vue&type=template&id=8539bbca&scoped=true"
import script from "./MessageBoardComment.vue?vue&type=script&lang=js"
export * from "./MessageBoardComment.vue?vue&type=script&lang=js"
import style0 from "./MessageBoardComment.vue?vue&type=style&index=0&id=8539bbca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8539bbca",
  null
  
)

export default component.exports